import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import TimeIntervalStep from "../../../../../../../shared/wizard/steps/timeIntervalStep";
import { EDealRequestTimeInterval } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnSwapStep_15 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardBuy) => void;
  data: EDealRequestTimeInterval | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnSwapStep_15 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISelectionByOwnSwapStep_15) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_14);
    onReset(["timeIntervalTypeView"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.selectionSteps.swap.step_16);
  };

  return (
    <div>
      <TimeIntervalStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="view"
        text="Желаемое время просмотра:"
      />
    </div>
  );
};

export default SelectionByOwnSwapStep_15;
